<template>
<div class="container container--small pdt-50 ">
<div class="t-headline11 font-m mgb-8 pdl-24 pdr-24">{{$t('1537')}}</div>
<div class="t-body1 t-color-bodyGrayA font-r pdl-24 pdr-24">{{$t('758')}}</div>
			<div class="mgt-40 pdl-24 pdr-24">
				<div class="mdc-select mdc-select--outlined w-full mdc--select__custom seleduty" :class="selectedDuty?'hasActiveVal':''" id="selectDuty">
					<i class="mdc-select__dropdown-icon select-icon-custom"></i>
					<select class="mdc-select__native-control mdc-select__anchor h-46 mdc-select-control-custom t-body6 select-no-appearance" v-model="selectedDuty">
						<option :value="null">
							{{$t('759')}}
						</option>
						<option v-for="duty in dutyList" :key="duty.value" :value="duty">
							{{duty.text}}
						</option>
					</select>
					<div class="mdc-notched-outline">
						<div class="mdc-notched-outline__leading"></div>
						<div class="mdc-notched-outline__notch">
							<!-- <label class="mdc-floating-label">{{$t('759')}}</label> -->
						</div>
						<div class="mdc-notched-outline__trailing"></div>
					</div>
				</div>
			</div>

			<div class="mgt-24 pdl-24 pdr-24">
				<div class="mdc-select mdc-select--outlined w-full mdc--select__custom resposib" :class="selectedResponsibility?'hasActiveVal':''" id="selectResponsibility">
					<i class="mdc-select__dropdown-icon select-icon-custom"></i>
					<select class="mdc-select__native-control mdc-select__anchor h-46 mdc-select-control-custom t-body6 select-no-appearance" v-model="selectedResponsibility">
						<option :value="null">
							{{$t('760')}}
						</option>
						<option v-for="responsibility in responsibilityList" :key="responsibility.value" :value="responsibility">
							<!-- {{$t('responsibility.text')}} -->
							{{responsibility.text}}
						</option>
					</select>
					<div class="mdc-notched-outline">
						<div class="mdc-notched-outline__leading"></div>
						<div class="mdc-notched-outline__notch">
							<!-- <label class="mdc-floating-label">{{$t('760')}}</label> -->
						</div>
						<div class="mdc-notched-outline__trailing"></div>
					</div>
				</div>
			</div>

		<div class="mgt-50 mgb-50 pdl-24">
		<button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText b-radius4 mgr-8"  @click="next()" @keypress="next()" tabindex="0">
			<div class="mdc-button__ripple"></div>
			<span class="mdc-button__label t-body2 font-r">{{$t('1539')}}</span>
		</button>
		<button class="mdc-button bg-white t-color-secondaryBtnText b-radius4"  @click="cancelJoin()" @keypress="cancelJoin()" tabindex="0">
			<div class="mdc-button__ripple"></div>
			<span class="mdc-button__label t-body2 font-r">{{$t('1540')}}</span>
		</button>
		</div>
		</div>
</template>

<script>
/**
 * 회원가입 - 직무 직책 컴포넌트(sign up - duty & responsibility component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCSelect} from '@material/select';
import {MDCRipple} from '@material/ripple'
import joinApi from '@/api/joinApi.js'
import {mapState, mapMutations} from 'vuex'
import {joinMixin} from '@/mixins/join.js'

export default {
	data() {
		return {
			dutyList: {},
			responsibilityList: {},
			selectedDuty: null,
			selectedResponsibility: null
		}
	},

	mixins: [joinMixin],

	created() {
		if (!this.join.terms.PRIVACY_STATEMENT) {
			this.moveJoin2Intro()
		}
	},

	watch: {
		selectedDuty: function(value) {
			this.fatchResponsibilityData()
		}
	},

	mounted() {
		this.setMaterialUi()
		this.fatchDutyData()
	},


	computed: {
		...mapState('join',{
			join : state => state,
		}),
	},


	methods: {
		// Store 변이 정의(define store mutation)
		...mapMutations('join', ['SET_RESPONSIBILITY', 'SET_DUTY', 'SET_DUTYNAME', 'SET_RESPONSIBILITYNAME']),

		setMaterialUi() {
			const selects = [].map.call(document.querySelectorAll('.mdc-select'), function(el) {
				let select = new MDCSelect.attachTo(el)
				return select
			})

			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})
		},

		// get duty data
		fatchDutyData() {
			joinApi.duty().then((response) => {
				this.dutyList = response.data.data

				if (this.join.duty) {
					this.selectedDuty = _.find(this.dutyList, (item) => {
						return item.value === this.join.duty
					})
				}
			}).catch((err) => {
				console.log(err)
			})
		},
		// get responsibility data
		fatchResponsibilityData() {
			if (this.selectedDuty) {
				let params = {
					dutyId: this.selectedDuty.value
				}

				this.selectedResponsibility = null

				if (this.selectedDuty) {
					joinApi.responsibility(params).then((response) => {
						this.responsibilityList = response.data.data
						if (this.join.responsibility) {
							this.selectedResponsibility = _.find(this.responsibilityList, (item) => {
								return item.value === this.join.responsibility
							})

							if (!this.selectedResponsibility) {
								this.selectedResponsibility = null
							}
						}

					}).catch((err) => {
						console.log(err)
					})
				}else {
					this.responsibilityList = {}
				}
			}


		},

		// next
		next() {
			if (this.selectedResponsibility && this.selectedDuty) {
				this.SET_DUTY(this.selectedDuty.value)

				this.SET_DUTYNAME(this.selectedDuty.text)
				this.SET_RESPONSIBILITY(this.selectedResponsibility.value)
				this.SET_RESPONSIBILITYNAME(this.selectedResponsibility.text)

				let params = {
					responsibility: this.selectedResponsibility.value
				}

				// 코드 인증 사용여부 (get auth Way Responsibility)
				joinApi.authWayResponsibility(params).then((response) => {
					if (response.data.data.usage) {
						this.$router.push({
							name: 'Join2Code', query: this.$route.query
						})
					}else {
						if (this.join.socialLink.type === 'google' || this.join.socialLink.type === 'facebook' || this.join.socialLink.type === 'firebase') {
							this.$router.push({
								name: 'Join2SocialInput', query: this.$route.query
							})
						}else {
							this.$router.push({
								name: 'Join2Name', query: this.$route.query
							})
						}

					}
				}).catch((err) => {
					console.log(err)
				})
			}else {
				this.$snackOpen({
					// contents:'소속을 모두 선택하세요.'
					contents: this.$t('761'),
					btnDisplay: ''
				}).then(() => {})
			}
		},
	}
}
</script>
<style scoped>
.mdc-floating-label{
	top: 24px!important;
}
/* .mdc-floating-label.mdc-floating-label--float-above{
	top:17px!important;
} */
.mdc-select-control-custom{
	border-radius: 4px;
  padding-top: 10px;
}

.mdc--select__custom.hasActiveVal:not(.mdc-select--disabled) .mdc-notched-outline__leading, .mdc--select__custom.hasActiveVal:not(.mdc-select--disabled) .mdc-notched-outline__notch, .mdc--select__custom.hasActiveVal:not(.mdc-select--disabled) .mdc-notched-outline__trailing{
	border-color: var(--Textfeildactive);
}

.mdc-select--outlined.hasActiveVal select  {
  color: var(--HeadlineBlack) !important;
}

.mdc-select--outlined.seleduty select option {
	color: var(--BodygrayA) !important;
}

.mdc-select--outlined.resposib select option {
	color: var(--BodygrayA) !important;
}
</style>
